import { FunctionComponent, useMemo } from 'react';
import { Tooltip } from '../../../../../Tooltip';
import styles from './styles.module.scss';
import { Temporal } from 'temporal-polyfill';
import { TimezoneDate } from '../../../../../TimezoneDate';

const shortDateTimeWithTimezoneOptions = {
    day: 'numeric',
    month: 'numeric',
    year: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
} as const;

type MultipleDaysTextProps = {
    startDate: Temporal.ZonedDateTime;
    endDate: Temporal.ZonedDateTime;
};

export const MultipleDaysText: FunctionComponent<MultipleDaysTextProps> = ({
    startDate,
    endDate,
}) => {
    const timezone = useMemo(() => startDate.timeZoneId, [startDate]);

    return (
        <Tooltip tooltip={timezone}>
            <div
                className={styles.multipleDatesText}
                role="textbox"
                aria-label="Multiple days text"
            >
                <div>
                    <span className={styles.label}>From: </span>
                    <TimezoneDate date={startDate} format={shortDateTimeWithTimezoneOptions} />
                </div>

                <div>
                    <span className={styles.label}>To: </span>
                    <TimezoneDate date={endDate} format={shortDateTimeWithTimezoneOptions} />
                </div>
            </div>
        </Tooltip>
    );
};
